export interface CellFunction {
  (element: any): any;
}

export interface ActionResult {
  draw: number;
  recordsTotal: number;
  recordsFiltered: number;
  data?: any;
}

export class TableHeader {
  columnType?: string ; // Table Column 類型 => textbox,checkbox
  columnDef: string;  // Table Column Name
  header: string;     // Table Head Display
  cell?: CellFunction = null;
  CellStyle?: CellFunction = null;
}

export class TableSetting {
  IdColumnName = '';
  HeadStyle: any;
  CellStyle: any;
  CorrespondTableHeard: TableHeader[];
  // DisplayedColumns: string[];
  ItemTitle?: Function = null;
  CanUpdate = false;
  CanDelete = false;
  CanMonitor = false;
  ShowActionIcon = true;
  CanCheck = false;
  CanSort = true;
}

